
import Vue from 'vue'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import { postProjectModule, patchProject, createBklrProject, getProject } from '@/utils/project'
const PostProjectModuleDialog = Vue.extend({
    mixins: [],
    components: { DialogTemplate },

    props: {
        props: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: false,
            bklrProject: '',
            requestForNewCardReaders: false,
            requestTransferOfExistingCardReaders: '',
        }
    },

    computed: {
        moduleId(): string {
            return this.props.moduleId
        },
        project() {
            return this.props.project
        },
        moduleParams() {
            const filters: Record<string, string | boolean> = {}
            if (this.requestForNewCardReaders) {
                filters.requestContactForNewCardReaders = true
            }
            if (this.requestTransferOfExistingCardReaders) {
                filters.requestTransferOfExistingCardReaders =
                    this.requestTransferOfExistingCardReaders
            }
            return filters
        },
    },

    methods: {
        async postModule() {
            this.loading = true
            let project = null as any
            let projectModule = null as any
            projectModule = await postProjectModule(
                this.moduleId,
                this.project,
                this.moduleParams
            ).catch(async (error: any) => {
                if (error.data.response.data.errors[0].code == 'moduleAlreadyExists') {
                    this.$store.commit('closeSnackbar')
                    project = await getProject(this.project.id, ['modules'])

                    if (project.id) {
                        projectModule = project.modules.data.find(
                            (module) => module.module.data.id == this.moduleId
                        )
                        this.$emit('close', { projectModule: projectModule, project: project })
                    }
                } else {
                    this.$store.commit('setErrorSnackBar', {
                        data: error.data.response.data.errors,
                        text: this.$t('vbit_error.default_header'),
                    })
                }
                this.loading = false
            })

            try {
                if (projectModule) {
                    if (
                        (this.moduleId == 'personnel' || this.moduleId === 'access') &&
                        !this.project.bklrId
                    ) {
                        if (this.bklrProject) {
                            project = await patchProject({
                                id: this.project.id,
                                bklrId: this.bklrProject,
                            })
                        } else if (this.project.canCreateBklrProject) {
                            project = await createBklrProject(
                                this.project.id,
                                projectModule.updatedAt
                            )
                        }
                    }
                }
            } catch (error: any) {
                this.$store.commit('setErrorSnackBar', {
                    data: error.data.response.data.errors,
                    text: this.$t('vbit_error.default_header'),
                })
            } finally {
                this.$emit('close', { projectModule: projectModule, project: project })
                this.loading = false
            }
        },
    },
})

export default PostProjectModuleDialog
